export const SET_CLIENT_SELECT = "SET_CLIENT_SELECT";
export const SET_COMPANY_SELECT = "SET_COMPANY_SELECT";
export const SET_BRANCH_SELECT = "SET_BRANCH_SELECT";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_TYPE = "SET_USER_TYPE";
export const SET_USER_ROLE = "SET_USER_ROLE";
